<template>
  <div class="virtual-account-container" @click.stop>
    <div class="credit-card-container" pointClass="j-open-credit-card">
      <p class="title-tips">{{ letter.pleaseCard }}</p>
      <div class="card-container">
        <div
          class="card-item j-credit-card-item pay-way-ico-wrap"
          v-for="(card, index) in creditCardList"
          :pointValue="card"
          :class="{ active: curCreditCard === card }"
          @click="selectCreditCard(card)"
          :key="index"
        >
          <img
            class="pay-way-icon"
            :src="getCurPayWayIcon(card)"
            alt="payway icon"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PAYTYPE_ICON_URL } from '@utiles/officialStore';
import { GET_CARD_SCHEMES_ACTION, SET_CREDIT_CARD } from '@store/officialStore';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'CreditCard',
  props: {
    curPayType: {
      require: true
    },
    languages: {
      require: true
    },
    curLocationVal: {
      require: true
    },
    discountTransMount: {
      require: true
    },
    curCoins: {
      require: true
    },
    isCoins: {
      require: true
    }
  },
  data() {
    return {};
  },
  methods: {
    getCurPayWayIcon(cardType) {
      return PAYTYPE_ICON_URL + 'credit_card/' + cardType + '.png';
    },
    selectCreditCard(card) {
      this.$store.commit(SET_CREDIT_CARD, card);
    },
    getCardSchemes() {
      // 金额有三种情况：购物车、非购物车、代币
      let amount = 0;
      if (this.isCart) {
        amount = this.cartDiscountTransMount;
      } else {
        amount = this.isCoins
          ? this.curCoins.TRANS_AMOUNT
          : this.discountTransMount;
      }
      this.$store.dispatch(GET_CARD_SCHEMES_ACTION, {
        currency: this.curPayType.currency,
        game_id: this.$store.state.gameId,
        location: this.curLocationVal,
        amount: amount,
        submit_type: this.isCoins ? 2 : 0 //充值代币余额时传2，否则不传或者传0
      });
    }
  },
  created() {
    this.getCardSchemes();
  },
  watch: {
    // 如果使用优惠券则重新请求接口, 区分是否购物车
    discountTransMount() {
      if (this.isCart || this.isCoins) {
        return;
      }
      this.getCardSchemes();
    },
    cartDiscountTransMount() {
      if (this.isCart) {
        this.getCardSchemes();
      }
    },
    curCoins() {
      if (this.isCoins) {
        this.getCardSchemes();
      }
    },
    curLocationVal() {
      this.getCardSchemes();
    }
  },
  computed: {
    ...mapState({
      creditCardList: state => state.creditCardList,
      curCreditCard: state => state.creditCard,
      isCart: state => state.cart.isCart,
      letter: state => state.letter
    }),
    ...mapGetters(['cartDiscountTransMount'])
  },
  components: {}
};
</script>

<style lang="scss" scoped>
.virtual-account-container {
  display: block;
  position: relative;
  margin-bottom: 20px;
  width: 100%;
  cursor: pointer;
}
.credit-card-container {
  width: 100%;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  .title-tips {
    font-size: 20px;
    color: var(--channel-name);
    margin: 20px 0 15px;
  }
  .card-container {
    display: flex;
    flex-wrap: wrap;
    .card-item {
      margin: 5px;
      transition: box-shadow 0.2s;
      &.active {
        box-shadow: 0 0 6px 3px #a66324;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          right: 5px;
          top: 5px;
          @psetbg ('credit-card-active.png', false, false);
          width: 18px;
          height: 18px;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
